import type { MouseOperate } from '@/plugins/mouse-operate';
import type { Displacement } from './displacement';

/**
 * 绑定基础操作结果与光标提示。
 *
 * 控制器只读取 MouseOperate 事件公开字段，并只调用传入的 Displacement 实例，
 * 从而让事件映射可独立测试，也避免 displacement 反向依赖基础操作内部实现。
 */
export const bindMouseOperateDisplacement = (mouseOperate: MouseOperate, displacement: Displacement) => {
    const clear = () => displacement.clear();
    const cleanups = [
        // mouseOperate.onMoveAfterUpdate((event) => {
        //     displacement.set({
        //         type: 'move',
        //         x: event.pointerX,
        //         y: event.pointerY,
        //         left: event.appliedX,
        //         top: event.appliedY,
        //     });
        // }),
        // mouseOperate.onMoveEnd(clear),
        mouseOperate.onResizeAfterUpdate((event) => {
            displacement.set({
                type: 'resize',
                x: event.pointerX,
                y: event.pointerY,
                width: event.width,
                height: event.height,
                isMin: event.isMin,
            });
        }),
        mouseOperate.onResizeEnd(clear),
        mouseOperate.onScaleAfterUpdate((event) => {
            // 兼容旧实现：scale 复用 resize 的尺寸提示样式。
            displacement.set({
                type: 'resize',
                x: event.pointerX,
                y: event.pointerY,
                width: event.width,
                height: event.height,
                isMin: event.isMin,
            });
        }),
        mouseOperate.onScaleEnd(clear),
        mouseOperate.onRotateAfterUpdate((event) => {
            displacement.set({
                type: 'rotate',
                x: event.pointerX,
                y: event.pointerY,
                rotate: event.rotate,
            });
        }),
        mouseOperate.onRotateEnd(clear),
        mouseOperate.onCancel(clear),
    ];

    /** 一次性解绑本控制器建立的全部实例事件监听。 */
    return () => cleanups.forEach((cleanup) => cleanup());
};
